import React from 'react';
import { AuthProvider } from '@asgardeo/auth-react';
import { asgardeoConfig } from './services/asgardeoConfig';
import Authenticate from './components/Login/Authenticate';
import EmailTest from './components/Login/EmailTest'; // Import for testing

// ---------------------------
// Root App Component
// ---------------------------
function App() {
  // Temporarily show email test for debugging
  const showEmailTest = false; // Set to false to go back to normal auth flow

  if (showEmailTest) {
    return <EmailTest />;
  }

  return (
    <AuthProvider config={asgardeoConfig}>
      <Authenticate />
    </AuthProvider>
  );
}

export default App;
